import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import tgApi from '../../utils/tgApi';

export const fetchSettings = createAsyncThunk(
  'settings/fetchSettings',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await tgApi.getSettings();
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || '설정을 불러올 수 없습니다.');
    }
  }
);

export const saveSettings = createAsyncThunk(
  'settings/saveSettings',
  async (settings, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await tgApi.updateSettings({ settings });
      // 저장 후 최신 설정 다시 로드
      dispatch(fetchSettings());
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || '설정 저장에 실패했습니다.');
    }
  }
);

const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    items: {},
    loading: false,
    saving: false,
    error: null,
  },
  reducers: {
    clearSettingsError: (state) => { state.error = null; },
    updateLocalSetting: (state, action) => {
      const { key, value } = action.payload;
      state.items[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => { state.loading = true; })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.loading = false;
        const settings = {};
        if (Array.isArray(action.payload)) {
          action.payload.forEach((s) => { settings[s.key] = s.value; });
        } else if (typeof action.payload === 'object') {
          // SettingResponse dict: { key: { key, value, description, ... } }
          Object.entries(action.payload).forEach(([k, v]) => {
            settings[k] = (v && typeof v === 'object' && 'value' in v) ? v.value : v;
          });
        }
        state.items = settings;
      })
      .addCase(fetchSettings.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(saveSettings.pending, (state) => { state.saving = true; state.error = null; })
      .addCase(saveSettings.fulfilled, (state) => { state.saving = false; })
      .addCase(saveSettings.rejected, (state, action) => { state.saving = false; state.error = action.payload; });
  },
});

export const { clearSettingsError, updateLocalSetting } = settingsSlice.actions;
export default settingsSlice.reducer;
